import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class AppConfig {

    private _minAppVersion: string | null;
    private _appEnabled: boolean;

    public constructor(minAppVersion: string | null, appEnabled: boolean) {

        this._minAppVersion = minAppVersion;
        this._appEnabled = appEnabled;
    }

    public get minAppVersion(): string | null {
        return this._minAppVersion;
    }

    public set minAppVersion(value: string | null) {
        this._minAppVersion = value;
    }

    public get appEnabled(): boolean {
        return this._appEnabled;
    }

    public set appEnabled(value: boolean) {
        this._appEnabled = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): AppConfig {

        const minAppVersion: string | null = safeParseNullDefault<string>(json?.minVersion, '');
        const appEnabled: boolean = safeParse<boolean>(json?.enabled, false);

        return new AppConfig(minAppVersion, appEnabled);
    }
}

export default AppConfig;